import {UserDetailsVM} from '@generated/interfaces';

export const useCanManageApprovals = (user?: UserDetailsVM) =>
  !!(user?.isAdmin || user?.isManager || user?.isAcademyApprover);
